"use client";

// Narrow, Node-free subpath — NOT the `@workspace/ai/capabilities` barrel,
// which would pull the sandbox managers (`node:fs`) and logger
// (`node:async_hooks`) into this client bundle.
import { PROGRESSIVE_DISCLOSURE_TOOL_NAMES } from "@workspace/ai/capabilities/progressive-disclosure";
import { lazy } from "react";
import type { ToolUIRegistry } from "../../tool-renderer";

/**
 * Registry entries for the progressive-disclosure proxy tools
 * (`discoverCapabilityTools` + `callCapabilityTool`). The proxy tools are
 * compose-time-injected — they don't appear in the static `AllToolNames`
 * union (only their inner targets do, when an always-on capability exposes
 * them directly) — so they register by their literal runtime names.
 *
 * See ADR-057.
 */
export const progressiveDisclosureToolRegistry: ToolUIRegistry = {
  [PROGRESSIVE_DISCLOSURE_TOOL_NAMES.discover]: {
    kind: "step",
    category: "code",
    view: lazy(() =>
      import("./discover-view").then(({ DiscoverCapabilityToolsView }) => ({
        default: DiscoverCapabilityToolsView,
      }))
    ),
  },
  [PROGRESSIVE_DISCLOSURE_TOOL_NAMES.call]: {
    kind: "step",
    category: "code",
    view: lazy(() =>
      import("./call-view").then(({ CallCapabilityToolView }) => ({
        default: CallCapabilityToolView,
      }))
    ),
  },
};
